import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/steam-symbol': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M395.5 177.5C395.5 211.3 368 238.5 334.5 238.5 300.7 238.5 273.5 211.2 273.5 177.5S300.8 116.5 334.5 116.5C368 116.5 395.5 143.7 395.5 177.5zM448 177.7C448 240.7 397 291.5 334.3 291.5L225 371.3C221 414.3 184.5 448.1 140.5 448.1 100 448.1 65.8 419.3 57.5 381.1L0 358V250.7L97.2 290C112.3 280.8 129.4 276.7 149.2 278.5L220.2 176.8C220.7 114.5 271.7 64 334.2 64 397 64 448 115 448 177.7zM203 363C203 328.3 175.2 300.5 140.5 300.5 136 300.5 131.5 301 127 302L153 312.5C178.5 322.7 191 351.5 180.7 377 170.5 402.5 141.5 415 116 404.5 105.8 400.5 95.5 396.2 85.3 392.3 95.8 412 116.5 425.5 140.5 425.5 175.2 425.5 203 397.7 203 363zM410.5 177.7C410.5 135.7 376.2 101.5 334.3 101.5 292 101.5 257.8 135.7 257.8 177.7 257.8 219.9 292.1 253.9 334.3 253.9 376.2 254 410.5 220 410.5 177.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/steam-symbol.js
// module id = Orcx
// module chunks = 144